import React from 'react'
import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

Modal.setAppElement('#root');
const PreviewMultimediaImageModal = ({ modalImageIsOpen, closeModal, previewFormData }) => {

    let subtitle;

  function afterOpenModal() {
    
    subtitle.style.color = "#f00";
  }

  return (
    <div>
    <Modal
      isOpen={modalImageIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Previsualización Imagen"
    >
      <div>Previsualización Imagen</div>
      <form>
      <div style={{ height: "250px", width: "250px" }}>
      <img style={{ maxWidth: "100%;" , height: "auto;"  }} src={previewFormData.url} alt="virtual"></img>
      </div>
      
      </form>
    </Modal>
  </div>
  )
}

export default PreviewMultimediaImageModal